import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectTurnstileSiteKey, provideTurnstileSiteKey] =
  createNoopInjectionToken<string>('Turnstile Site Key');
